import { Link } from 'react-router-dom';

const newsItems = [
  {
    id: 1,
    category: '公司新闻',
    date: '2026-06-20',
    title: '蚂蚁链控股集团与中信证券国际达成战略合作，共建跨境量化交易平台',
    excerpt: '双方将在跨境量化策略研发、数据共享与风控技术等领域展开深度合作。',
    image: 'https://readdy.ai/api/search-image?query=Professional%20business%20partnership%20visualization%2C%20dark%20navy%20and%20gold%20abstract%20elements%2C%20financial%20data%20overlay%2C%20clean%20sophisticated%20style%2C%20no%20text%2C%20dark%20atmosphere&width=600&height=400&seq=news-pv-dark-01&orientation=landscape',
  },
  {
    id: 2,
    category: '行业洞察',
    date: '2026-06-15',
    title: '2026年下半年全球宏观展望：利率拐点下的资产配置新范式',
    excerpt: '蚂蚁基金研究团队发布最新宏观研究报告，深入分析美联储政策路径与多资产配置策略。',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20global%20macroeconomic%20analysis%2C%20world%20map%20data%20nodes%20in%20dark%20navy%2C%20gold%20accents%2C%20professional%20research%20aesthetic%2C%20no%20text%2C%20dark%20mood&width=600&height=400&seq=news-pv-dark-02&orientation=landscape',
  },
  {
    id: 3,
    category: '合规学习',
    date: '2026-06-10',
    title: '蚂蚁链控股集团完成SFC第9类牌照年度合规审查，持续强化风控治理',
    excerpt: '集团旗下持牌主体顺利通过香港证监会年度审查，合规管理体系获监管机构高度认可。',
    image: 'https://readdy.ai/api/search-image?query=Professional%20compliance%20regulatory%20visualization%2C%20shield%20pattern%20with%20checkmark%2C%20dark%20navy%20background%2C%20gold%20accent%2C%20trustworthy%20corporate%20mood%2C%20no%20text&width=600&height=400&seq=news-pv-dark-03&orientation=landscape',
  },
];

export default function NewsPreview() {
  return (
    <section className="py-20 md:py-28 bg-background-100">
      <div className="px-6 md:px-12 lg:px-20">
        <div className="max-w-[1400px] mx-auto">
          <div className="flex flex-col md:flex-row md:items-end justify-between mb-14 gap-4">
            <div>
              <p className="text-xs md:text-sm font-semibold tracking-[0.25em] uppercase text-accent-500 mb-3">News &amp; Insights</p>
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-100">新闻动态</h2>
            </div>
            <Link
              to="/news"
              className="inline-flex items-center gap-1.5 text-sm font-semibold text-accent-500 hover:text-accent-400 transition-colors whitespace-nowrap"
            >
              查看全部
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
            {newsItems.map((item) => (
              <Link
                key={item.id}
                to="/news"
                className="group block bg-background-50 rounded-xl border border-background-300/30 overflow-hidden hover:border-accent-500/30 hover:-translate-y-1 transition-all duration-300"
              >
                <div className="relative h-44 md:h-48 overflow-hidden">
                  <img
                    src={item.image}
                    alt={item.title}
                    className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-background-50 via-transparent to-transparent"></div>
                  <div className="absolute top-3 left-3">
                    <span className="px-2.5 py-1 bg-background-100/85 backdrop-blur-sm rounded-full text-[10px] md:text-xs font-semibold text-primary-400 border border-background-300/30">
                      {item.category}
                    </span>
                  </div>
                </div>
                <div className="p-5">
                  <p className="text-[10px] md:text-xs text-foreground-600 mb-2">{item.date}</p>
                  <h3 className="text-sm md:text-base font-semibold text-foreground-200 leading-snug mb-2 line-clamp-2 group-hover:text-accent-400 transition-colors duration-200">
                    {item.title}
                  </h3>
                  <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2">
                    {item.excerpt}
                  </p>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}